import { Encoding } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { ChartTranslator } from '../chart-translator';
import { ensureMeasureNamesOnColorEncoding } from './translator-util';

export class BarLineTranslator implements ChartTranslator {
  translateHighChartsToMuze(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    return encoding.y.length > 0
      ? ensureMeasureNamesOnColorEncoding(encoding, encoding.y[0].id ?? '', 'row')
      : encoding;
  }

  translateMuzeToHighCharts(encoding: Encoding, format: Readonly<ChartTypes.ChartFormat>): Encoding {
    return encoding;
  }

  formatRequiresEncodingUpdate(
    oldFormat: Readonly<ChartTypes.ChartFormat>,
    newFormat: Readonly<ChartTypes.ChartFormat>
  ): boolean {
    return false;
  }
}
